import { SetCookie, getCookie, deleteCookie } from "./utils";

/* -------------------------------------------------------------------------
 * Follow-state cookie cache
 *
 * One cookie per host the viewer has followed: `_aps_fwd_<host_id>=1`.
 * - Read on first render so a Follow button shows "Following" immediately,
 *   before (and without waiting for) the API round-trip.
 * - Written on every successful follow/unfollow click.
 * - The cookie is a cache, never the source of truth. If the viewer followed
 *   on device A and the cookie isn't set on device B, the API will say
 *   `following: true` and the local state catches up.
 * - 30 day TTL matches the auth cookie (`_aps_t`); a follow that outlives it
 *   simply re-hydrates from the API.
 *
 * Shared by the event details organizer card and the /organizer/:slug profile
 * page so both read and write the exact same key.
 * ------------------------------------------------------------------------- */

export const followCookieName = (hostId) => `_aps_fwd_${hostId}`;

export const readFollowCookie = (hostId) => {
    if (!hostId) return false;
    return getCookie(followCookieName(hostId)) === "1";
};

export const writeFollowCookie = (hostId, isFollowing) => {
    if (!hostId) return;
    if (isFollowing) {
        SetCookie(followCookieName(hostId), "1", 30);
    } else {
        deleteCookie(followCookieName(hostId));
    }
};
